import React, {useState} from 'react';
import registeredComponent from "../../utils/registeredComponent";
import XMLViewer from "../shared/XMLViewer";

const FactsWebProvidedXML = ({xml}) => {
  const [raw, setRaw] = useState(false);

  return <React.Fragment>
    <h2>FACTS Web Provided XML</h2>

    <button className='btn btn-light' onClick={() => setRaw(!raw)} style={{marginBottom: '1rem'}}>Toggle</button>

    {raw && <p>{xml}</p> || <XMLViewer xml={xml}/>}
  </React.Fragment>;
}

export default registeredComponent('FactsWebProvidedXML')(FactsWebProvidedXML);
